<template>
  <div id="app">
    <router-view />
    <commom-page-button-widge></commom-page-button-widge>
  </div>
</template>

<style lang="scss">
#app {
  font-family:  PingFangSC, MicrosoftYaHei, PingFangSC-Regular;
  p {
    font-family:  "PingFangSC", "MicrosoftYaHei", "PingFangSC-Semibold";
  }
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
<script>
import commomPageButtonWidge from "./views/components/commomPageButtonWidge";
import mixUmeng from '@/mixins/mixUmeng'
export default {
  components: {
    commomPageButtonWidge,
  },
  mixins: [mixUmeng],
  mounted() {
    if (this._isMobile()) {
      this.$router.replace("/mobile");
    }
    // else {
    //   this.$router.replace("/");
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>
